import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationFirst,
    PaginationItem,
    PaginationLast,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from '@/components/ui/pagination';
import { getPaginationRange } from '@/lib/pagination-range';

interface BookPaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    /** Maximum numbered pages to render. Omit to render every page. */
    maxVisiblePages?: number;
    showFirstLast?: boolean;
}

export function BookPagination({ currentPage, totalPages, onPageChange, maxVisiblePages, showFirstLast = true }: BookPaginationProps) {
    if (totalPages <= 1) {
        return null;
    }

    const range = getPaginationRange(currentPage, totalPages, maxVisiblePages);
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === totalPages;

    return (
        <Pagination aria-label="Book pagination">
            <PaginationContent>
                {showFirstLast ? (
                    <PaginationItem>
                        <PaginationFirst
                            disabled={isFirstPage}
                            onClick={() => onPageChange(1)}
                        />
                    </PaginationItem>
                ) : null}

                <PaginationItem>
                    <PaginationPrevious
                        disabled={isFirstPage}
                        onClick={() => onPageChange(currentPage - 1)}
                    />
                </PaginationItem>

                {range.map((item, index) =>
                    item === 'ellipsis' ? (
                        <PaginationItem key={`ellipsis-${index}`}>
                            <PaginationEllipsis />
                        </PaginationItem>
                    ) : (
                        <PaginationItem key={item}>
                            <PaginationLink
                                isActive={item === currentPage}
                                onClick={() => onPageChange(item)}
                            >
                                {item}
                            </PaginationLink>
                        </PaginationItem>
                    ),
                )}

                <PaginationItem>
                    <PaginationNext
                        disabled={isLastPage}
                        onClick={() => onPageChange(currentPage + 1)}
                    />
                </PaginationItem>

                {showFirstLast ? (
                    <PaginationItem>
                        <PaginationLast
                            disabled={isLastPage}
                            onClick={() => onPageChange(totalPages)}
                        />
                    </PaginationItem>
                ) : null}
            </PaginationContent>
        </Pagination>
    );
}
